import { Badge } from '@chakra-ui/react';

const STATUS_CONFIG = {
  offer_sent: {
    bg: 'green.100',
    color: 'green.600',
    border: 'none',
    label: 'New',
  },
  pending_signature: {
    bg: 'transparent',
    color: 'orangePrimary',
    border: '1px solid',
    borderColor: 'orangePrimary',
    label: 'Awaiting signature',
  },
  signature_received: {
    bg: 'transparent',
    color: 'orangePrimary',
    border: '1px solid',
    borderColor: 'orangePrimary',
    label: 'Awaiting payment',
  },
  accepted: {
    bg: 'transparent',
    color: 'orangePrimary',
    border: '1px solid',
    borderColor: 'orangePrimary',
    label: 'Awaiting payment',
  },
};

const DEFAULT_CONFIG = {
  bg: 'transparent',
  color: 'orangePrimary',
  border: '1px solid',
  borderColor: 'orangePrimary',
  label: 'Review required',
};

const CustomPlanStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || DEFAULT_CONFIG;

  return (
    <Badge
      bg={config.bg}
      color={config.color}
      border={config.border}
      borderColor={config.borderColor}
      borderRadius="full"
      px={3}
      py={1}
      fontWeight="medium"
      textTransform="none"
      fontSize="sm"
    >
      {config.label}
    </Badge>
  );
};

export default CustomPlanStatusBadge;
